import { BaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { AppFeedbackInjection } from "features/appFeedback/di/AppFeedbackInjection";
import { injectable } from "tsyringe";
import { paramsChecking } from "utils/helpersInTs/helpersInTs";
import { AppFeedbackRequestEntity } from "../entities/AppFeedbackRequestEntity";
import { AppFeedbackResponseEntity } from "../entities/AppFeedbackResponseEntity";
import { IAppFeedbackRepository } from "../repositories/IAppFeedbackRepository";

@injectable()
export class AppFeedbackUseCase {
  private appFeedbackRepo: IAppFeedbackRepository;

  constructor() {
    this.appFeedbackRepo = AppFeedbackInjection.getRepo();
  }

  private checkParams(value: AppFeedbackRequestEntity): AppFeedbackRequestEntity {
    return {
      ...value,
      phoneNumber: paramsChecking(value?.phoneNumber, "input"),
    };
  }

  async getAppFeedbacks(
    params: AppFeedbackRequestEntity,
  ): Promise<ListBaseApiResponseModel<AppFeedbackResponseEntity>> {
    const updatedParams = this.checkParams(params);
    return await this.appFeedbackRepo.getList(updatedParams);
  }

  async getAppFeedbackDetail(
    id: string,
  ): Promise<BaseApiResponseModel<AppFeedbackResponseEntity>> {
    return await this.appFeedbackRepo.getDetail(id);
  }
}
